import * as React from "react";

import { Drawer } from "antd";
import { Button } from "#components/primitive/button";
import { useAnalytics } from "#structure/providers/analytics/analytics-provider";
import { useGetCurrentEmployee } from "#resources/hooks/integrations/auth/query";

import Icon from "#components/icon";
import s from "./suport-area.scss";
import { contextLevelFromUrl } from "#resources/helpers/url/url";

const DEFAULT_WIDTH_DESKTOP = 466;
const DEFAULT_WIDTH_MOBILE = "100%";
interface SuportAreaProps {
	type: "mobile" | "desktop";
	isOpen: boolean;
	placeName: string;
	handleChangeIsOpen: (isOpen: boolean) => void;
}
export function SuportArea({
	placeName,
	type,
	isOpen,
	handleChangeIsOpen,
}: SuportAreaProps) {
	const { data: currentEmployee } = useGetCurrentEmployee({});
	const { sendEvent } = useAnalytics();
	const contextLevel = contextLevelFromUrl();

	const handleContactSupport = () => {
		sendEvent("SUPPORT_WHATSAPP", {
			actionType: "click",
			userName: currentEmployee?.name ?? "",
			userLogin: currentEmployee?.username ?? "",
			placeName: placeName ?? "",
			positionName: currentEmployee?.role?.name ?? "",
			dateUserAction: new Date().toISOString(),
			contextLevel,
		});
	};

	return (
		<div>
			{isOpen ? (
				<Drawer
					className={s.suportArea}
					width={type === "mobile" ? DEFAULT_WIDTH_MOBILE : DEFAULT_WIDTH_DESKTOP}
					open={isOpen}
					title={
						<div className={s.headerInfos}>
							{type === "mobile" && <div className={s.handleMobile} />}
							<div className={s.titleContainer}>
								<h1 className={s.title}>{"Central de ajuda"}</h1>
								{type === "desktop" && (
									<Icon
										icon="close"
										className={s.closeButton}
										onClick={() => handleChangeIsOpen(false)}
									/>
								)}
							</div>
						</div>
					}
					placement={type === "mobile" ? "bottom" : "right"}
					closable={false}
					onClose={() => handleChangeIsOpen(false)}
					footer={
						type === "desktop" && (
							<div className={s.footer}>
								<Button variant="ghost" onClick={() => handleChangeIsOpen(false)}>
									{"Fechar"}
								</Button>
							</div>
						)
					}
				>
					<div className={s.containerContacts}>
						<div className={s.contactWhatsApp}>
							<Icon className={s.iconChat} icon="chat" />
							<h2>Precisa de ajuda?</h2>
							<span>Converse com o nosso time de suporte.</span>
							<a
								className={s.link}
								onClick={handleContactSupport}
								href="https://api.whatsapp.com/send/?phone=5511977032633&text&type=phone_number&app_absent=0"
								target="_blank"
								rel="noopener noreferrer"
							>
								<span>Falar com o suporte</span>
								<Icon icon="arrow-right" />
							</a>
						</div>
					</div>
				</Drawer>
			) : null}
		</div>
	);
}
